/**
 * @module actions/agreement
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description Getting Agreements for workprovider from the API
 * @return {Promise} Axios promise
 */
export function getAgreements () {
  let url = API_URL + '/Agreement'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting Agreement constraints for workprovider from the API
 * @return {Promise} Axios promise
 */
export function getConstraints () {
  let url = API_URL + '/Agreement/Get'
  return dispatch => {
    return axios.get(url)
  }
}

export function getCustomerAgrements (customerId) {
  let url = API_URL + '/Agreement/Customer/Get/' + customerId
  return dispatch => {
    return axios.get(url)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/agreement.js